<template>
    <b-skeleton-wrapper
        :loading="loading"
    >
        <template #loading>
            <b-list-group class="mt-2">
                <b-list-group-item>
                    <b-skeleton width="45%"></b-skeleton>
                    <b-skeleton></b-skeleton>
                </b-list-group-item>
            </b-list-group>
        </template>
        <b-list-group class="mt-2">
            <b-list-group-item
                v-for="(notification, idx) in notifications"
                :key="idx"
            >
                <h5>Subject: {{ notification.subject }}</h5>
                <p v-html="notification.message"></p>
                <p>
                    <font-awesome-icon icon="info-circle" class="mr-2"></font-awesome-icon>
                    Sent {{ $moment.utc(notification.sent_at).local().format("LLLL") }} to <a :href="'mailto:'+notification.recipients">{{ notification.recipients }}</a>
                </p>
            </b-list-group-item>
            <b-list-group-item
                v-if="notifications.length == 0"
                variant="info"
            >
                <font-awesome-icon
                    icon="info-circle"
                    class="mr-2"
                ></font-awesome-icon>
                There are no previous notifications to show.
            </b-list-group-item>
        </b-list-group>
    </b-skeleton-wrapper>
</template>
<script>
export default {
    props: {
        class_: Object
    },
    data() {
        return {
            notifications: [],
            loading: true
        };
    },
    mounted() {
        this.loadNotifications();
    },
    methods: {
        loadNotifications() {
            this.loading = true;
            this.$api.get(
                "/api/teacher/previous-notifications",
                {
                    params: {
                        class_id: this.class_.id
                    }
                }
            ).then(({ data: { notifications } }) => {
                this.notifications = notifications;
                this.loading       = false;
            });
        }
    }
}
</script>